import React, { useState } from "react";
import Common_Heading_Holder from "../common_heading_holder/Common_Heading_Holder";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import { useNavigate } from "react-router-dom";
import Common_todays_offer_Card from "../common_todays_offer_Card/Common_todays_offer_Card";

const Common_todays_offer_swiper = ({
  button_color,
  background_color,
  multiple,

  ...props
}) => {
  const navigate = useNavigate();

  return (
    <section className="Common_Product_Swiper">
      <div className="card_heading_div">
        <Common_Heading_Holder
          headingText={"Today's Offers"}
          // viewShowAllButton={true}
          goto={`/category`}
        />
      </div>

      <div className="products_main_div">
        <Swiper
          spaceBetween={15}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          slidesPerView={3}
          modules={[Pagination]}
          autoplay={{ delay: 300 }}
          className="common_swiper"
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            350: {
              slidesPerView: 1.8,
            },
            768: {
              slidesPerView: 2.1,
            },
            992: {
              slidesPerView: 2.2,
            },
            1200: {
              slidesPerView: 3,
            },
            1400: {
              slidesPerView: 3,
            },
          }}
        >
          {props?.data?.length > 0 ? (
            props?.data?.map((item) => (
              <SwiperSlide key={item?.id}>
                <Common_todays_offer_Card
                  button_color={button_color}
                  prodImg={item?.Product?.image}
                  prodName={item?.Product?.name}
                  product={item?.Product}
                  item={item}
                  background_color={background_color}
                  goto={`/product-listing-sub-category/${
                    item?.id
                  }?category_name=${encodeURIComponent(
                    item?.name
                  )}&category_image=${encodeURIComponent(item?.image)}`}
                />
              </SwiperSlide>
            ))
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "40px 0",
                fontSize: "18px",
                color: "#666",
              }}
            >
              <span
                style={{
                  fontSize: "30px",
                  display: "block",
                  fontWeight: "bold",
                }}
              >
                🛒
              </span>
              <span style={{ fontWeight: "bold" }}>No products available</span>
            </div>
          )}
        </Swiper>
      </div>
    </section>
  );
};
export default Common_todays_offer_swiper;
